export const FILTER_DIALOG_MAX_WIDTH = "815px";
export const HARDCODED_REPORT_FILTERS_KEYS = [
  "phase",
  "location",
  "status",
  "city",
  "borough",
  "target closing date",
];
